export default __webpack_public_path__ + "static/media/tasks.faf75bcd.svg";